
import React from 'react'

export default function ProductDetailsComponent({ parentCategories,productItems, productTypesitemsData, categoryListItems, subCategoryListItems, handleChange }: any) {

    return (


        <div className="w-full font-bold space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
                {/* Product Type */}
                <div className="w-full pb-5">
                    <label className="block text-xs font-light">Product Type <span className="text-red-500">*</span></label>

                    <select
                        required
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        id="default"
                        onChange={(event: any) => {
                            handleChange(event.target.value, 'ProductTypeName');
                        }}
                        value={productItems?.ProductTypeName}
                    >
                        <option>--Select--</option>
                        {productTypesitemsData?.result?.items?.map((item: any, index: any) => (
                            <option value={item.Name} key={index}>{item.Name}</option>
                        ))}
                    </select>

                </div>

                {/* Category */}
                <div className="w-full pb-5">
                    <label className="block text-xs font-light">Category</label>
                    <div className="w-full border border-black border-opacity-50 text-xs rounded">
                        <select
                            className={`w-full rounded bg-opacity-0 text-xs py-2`}
                            id="default"
                            onChange={(event: any) => {
                                handleChange(event.target.value, 'CategoryName');
                            }}
                            value={productItems?.CategoryName}
                        >
                            <option>--Select--</option>
                            {parentCategories?.map((item: any, index: any) => (
                                <option value={item.Name} key={index}>{item.Name}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* SubCategory Name */}
                {productItems?.CategoryName && (
                    <>
                        {subCategoryListItems?.isLoading ? <div className="w-full pb-5">
                            <label className="block text-xs font-light">SubCategory Name</label>
                            <label className="block text-sm font-normal">Loading...</label>

                        </div> : (subCategoryListItems?.result?.items.length > 0 ? <div className="w-full pb-5">
                            <label className="block text-xs font-light">SubCategory Name</label>
                            <select
                                className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                                id="default"
                                onChange={(event: any) => {
                                    handleChange(event.target.value, 'SubCategoryName');
                                }}
                                value={productItems?.SubCategoryName}
                            >
                                <option>--Select--</option>
                                {subCategoryListItems?.result?.items?.map((item: any, index: any) => (
                                    <option value={item.Name} key={index}>{item.Name}</option>
                                ))}
                            </select>

                        </div> : <div className="w-full pb-5">
                            <label className="block text-xs font-light">No SubCategory Available</label>


                        </div>
                        )}
                    </>)}
                    
                {/* Vehicle Number */}
                <div className="w-full pb-5">
                    <label className="block text-xs font-light">Vehicle Number <span className="text-red-500">*</span></label>

                    <input
                        required
                        type="text"
                        name="value"
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        onChange={(event: any) => {
                            handleChange(event.target.value, 'VehicleNumber');
                        }}
                        value={productItems?.VehicleNumber}
                    />

                </div>

                {/* Vehicle Chassis Number */}
                <div className="w-full pb-5">
                    <label className="block text-xs font-light">Vehicle Chassis Number</label>

                    <input
                        type="text"
                        name="value"
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        onChange={(event: any) => {
                            handleChange(event.target.value, 'VehicleChassisNumber');
                        }}
                        value={productItems?.VehicleChassisNumber}
                    />

                </div>

                {/* Vehicle Brand */}
                <div className="w-full pb-5">
                    <label className="block text-xs font-light">Vehicle Brand <span className="text-red-500">*</span></label>

                    <input
                        required
                        type="text"
                        name="value"
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        onChange={(event: any) => {
                            handleChange(event.target.value, 'VehicleBrand');
                        }}
                        value={productItems?.VehicleBrand}
                    />
                </div>

                {/* Vehicle Model */}
                <div className="w-full pb-5">
                    <label className="block text-xs font-light">Vehicle Model <span className="text-red-500">*</span></label>

                    <input
                        required
                        type="text"
                        name="value"
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        onChange={(event: any) => {
                            handleChange(event.target.value, 'VehicleModel');
                        }}
                        value={productItems?.VehicleModel}
                    />
                </div>

                {/* Vehicle Year */}
                <div className="w-full pb-5">
                    <label className="block text-xs font-light">Vehicle Year <span className="text-red-500">*</span></label>

                    <input
                        required
                        type="text"
                        name="value"
                        className="border w-full border-black/50 text-xs rounded py-2 px-3 bg-gray-50"
                        onChange={(event: any) => {
                            handleChange(event.target.value, 'VehicleYear');
                        }}
                        value={productItems?.VehicleYear}
                    />
                </div>

            </div>


        </div>







    )
}